module.exports = __webpack_public_path__ + "static/media/carinsurancedoma.e6f2d8b8.svg";